import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next'; // Import the useTranslation hook
import { Link, useNavigate } from 'react-router-dom';
import { handleChange, handleSubmit } from "../../Controller/CreateJobCostController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import Draggable from 'react-draggable';

function CreateJobCost({ currentJobCost, onClose, onSuccess, JobID }) {
    const { t } = useTranslation(); // Initialize the useTranslation hook
    const getCurrentDate = () => {
        const today = new Date();
        return today.toISOString().split('T')[0];
    };
    const [formData, setFormData] = useState({
        FK_Issue_ID: JobID,
        vc_CostName: "",
        vc_Description: "",
        dt_EntryDate: getCurrentDate(),
        mon_Cost: "0.00",
        mon_OurCost: "0.00",
        TotalHours: "0",
        RateMethod: "0"
    });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme === "dark") { // Corrected the comparison operator
        accordTheme = "accordion-header-dark";
    }

    useEffect(() => {
        if (currentJobCost) {
            setFormData({
                FK_Issue_ID: JobID, vc_CostName: currentJobCost.vc_CostName,
                vc_Description: currentJobCost.vc_Description,
                dt_EntryDate: new Date(currentJobCost.dt_EntryDate).toISOString().split('T')[0],

                mon_Cost: currentJobCost.mon_Cost,
                mon_OurCost: currentJobCost.mon_OurCost,
                TotalHours: currentJobCost.TotalHours,
                RateMethod: currentJobCost.RateMethod
            });
        } else {
            setFormData({
                FK_Issue_ID: JobID, vc_CostName: "",
                vc_Description: "",
                dt_EntryDate: getCurrentDate(),
                mon_Cost: "0.00",
                mon_OurCost: "0.00",
                TotalHours: "0",
                RateMethod: "0"
            }); // Clear form data when switching to add mode
        }
    }, [currentJobCost]);

    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };

    const handleFormSubmit = (event) => {
        event.preventDefault(); // Prevent default form submission
        if (currentJobCost) {
            formData.ID = currentJobCost.PK_IssueCost_ID;
        } else {
            formData.ID = 0;
        }
        formData.FK_Issue_ID = JobID;
        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        const redirectUserList = () => {
            navigate('/JobsList?saved=true');
        };

        handleSubmit(event, formData, setFormData, setErrors, () => {
            let JobCostID = localStorage.getItem('JobCostID');
            JobCostID = JobCostID + 1;
            localStorage.setItem('JobCostID', JobCostID);
            onSuccess();
            //  redirectUserList();
        }, () => {
            let JobCostID = localStorage.getItem('JobCostID');
            JobCostID = JobCostID + 1;
            localStorage.setItem('JobCostID', JobCostID);
            onSuccess();
            //   redirectUserList();
        });

    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    return (
        <div>
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade jobCostModal show d-block" id="jobCostModal" tabIndex="-1" aria-labelledby="jobCostModalLabel" aria-hidden="true" data-backdrop="static">
                    <div className="modal-dialog modal-lg">
                        <Draggable handle=".modal-header" onStart={handleStart}
                            cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p"
                            bounds={{ top: 0, bottom: window.innerHeight - 400 }}>
                            <div className="modal-content">
                                <div className={`modal-header ${accordTheme}`}>
                                    <h5 className="modal-title" id="largeModalLabel">{currentJobCost ? "Edit Cost" : "Add Cost"}</h5>
                                    <button type="button" className="close" aria-label="Close" onClick={onClose}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="row mb-3" style={{ marginLeft: "-5px", marginTop: "10px",marginRight:"0px" }}>
                                        <div className="col-sm-12">
                                            <table style={{ width: "100%" }}>
                                                <tbody>
                                                    <tr>
                                                        <td style={{width:"13%"}}><label htmlFor="vc_CostName" style={{ float: "right" }}>Entry <span style={{ "color": "red" }}>*</span></label></td>
                                                        <td style={{width:"37%"}}>

                                                            <select name="vc_CostName" className='form-control' value={formData.vc_CostName} onChange={handleFieldChange}>
                                                                <option value="0">Select Entry</option>
                                                                <option value="S1">S1</option>
                                                                <option value="S2">S2</option>
                                                                <option value="S3">S3</option>
                                                                <option value="M">M</option>
                                                                <option value="BM">BM</option>
                                                            </select>
                                                            {errors.vc_CostName && <div style={{ "color": "red", "fontSize": "0.8vw" }}>{errors.vc_CostName}</div>}
                                                        </td>
                                                        <td style={{width:"13%"}}><label htmlFor="dt_EntryDate" style={{ float: "right" }}>Date &nbsp;&nbsp;</label></td>
                                                        <td style={{width:"37%"}}>
                                                            <input type="date" className="form-control" name="dt_EntryDate" value={formData.dt_EntryDate} onChange={handleFieldChange} />
                                                            {errors.dt_EntryDate && <div style={{ "color": "red", "fontSize": "0.8vw" }}>{errors.dt_EntryDate}</div>}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td><label htmlFor="mon_Cost" style={{ float: "right" }}>Sale Price <span style={{ "color": "red" }}>*</span></label></td>
                                                        <td>
                                                            <input type="text" className="form-control" name="mon_Cost" value={formData.mon_Cost} onChange={handleFieldChange} />
                                                            {errors.mon_Cost && <div style={{ "color": "red", "fontSize": "0.8vw" }}>{errors.mon_Cost}</div>}
                                                        </td>
                                                        <td><label htmlFor="mon_OurCost" style={{ float: "right" }}>Cost Price &nbsp;&nbsp;</label></td>
                                                        <td>
                                                            <input type="text" className="form-control" name="mon_OurCost" value={formData.mon_OurCost} onChange={handleFieldChange} />
                                                            {errors.mon_OurCost && <div style={{ "color": "red", "fontSize": "0.8vw" }}>{errors.mon_OurCost}</div>}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td><label htmlFor="vc_Description" style={{ float: "right" }}>Description <span style={{ "color": "red" }}>*</span></label></td>
                                                        <td>
                                                            <input type="text" className="form-control" name="vc_Description" value={formData.vc_Description} onChange={handleFieldChange} />
                                                            {errors.vc_Description && <div style={{ "color": "red", "fontSize": "0.8vw" }}>{errors.vc_Description}</div>}
                                                        </td>

                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="submit" className="btn btn-primary">
                                        <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} /> {currentJobCost ? " Update" : " Save"}
                                    </button>
                                    <button className="btn btn-danger" type="button" aria-label="Close" onClick={onClose}>
                                        <img src="assets/img/resources/close-button-icon.png" alt="Add icon" style={{ height: "10px" }} /> Close
                                    </button>
                                </div>
                            </div>
                        </Draggable>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default CreateJobCost;
